import { useTheme } from '@mui/styles';
import React from 'react';
import GoogleAnalytics from 'react-ga';
import GoogleAnalyticsGa4 from 'react-ga4';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ConstantsContext } from 'Lib/constant';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

const ANALYTICS_INTERESTS = ['TDH'];
const GA4_ANALYTICS = [];

interface RouteChangeTrackerProps extends RouteComponentProps {
    isAdmin: boolean;
}

const RouteChangeTrackerComponent = (props: RouteChangeTrackerProps) => {
    const {
        isAdmin,
        history
    } = props;

    const muiTheme = useTheme<ApplicationMuiTheme>();
    const constants = React.useContext(ConstantsContext);

    const addToAnalytics = (isAdmin, uiEnvLevel) => {
        const prop = isAdmin ? 'admin' : 'client';
        if (muiTheme?.app?.google?.[prop]) {
            const additionalAnalytics = muiTheme.app.google[prop].filter((
                config
            ) => config.environment && uiEnvLevel && uiEnvLevel.includes(config.environment));
            additionalAnalytics.forEach((obj) => {
                if (!ANALYTICS_INTERESTS.includes(obj.trackingName) && obj.trackingId.slice(0, 3) === 'UA-') {
                    ANALYTICS_INTERESTS.push(obj.trackingName);
                } else if (!GA4_ANALYTICS.includes(obj.trackingName) && obj.trackingId.slice(0, 2) === 'G-') {
                    GA4_ANALYTICS.push(obj.trackingName);
                }
            });
        }
    };

    const trackPage = page => {
        if (page === '/admin') {
            return;
        }

        GoogleAnalytics.set({ page });
        GoogleAnalytics.pageview(page, ANALYTICS_INTERESTS);
        GoogleAnalyticsGa4.set({ page });
        GoogleAnalyticsGa4.send({
            hitType: 'pageview',
            page: page,
            page_location: page,
            title: page
        });
    };

    React.useEffect(() => {
        addToAnalytics(isAdmin, constants.ENV);
        history.listen((location) => {
            trackPage(location.pathname);
        });
    }, [
        constants.ENV,
        history,
        isAdmin
    ]);

    // Component does not need to render anything
    return null;
};

export const RouteChangeTracker = withRouter(RouteChangeTrackerComponent);